import { render, staticRenderFns } from "./PayMe.vue?vue&type=template&id=643e5eae&scoped=true&lang=pug&"
import script from "./PayMe.vue?vue&type=script&lang=js&"
export * from "./PayMe.vue?vue&type=script&lang=js&"
import style0 from "./PayMe.vue?vue&type=style&index=0&id=643e5eae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643e5eae",
  null
  
)

export default component.exports